import { ComponentPropsWithoutRef } from "react";

export const InfoIcon = ({ ...props }: ComponentPropsWithoutRef<"svg">) => {
  return (
    <svg {...props} viewBox="0 0 24 24">
      <path
        d="M12 22C6.5 22 2 17.5 2 12S6.5 2 12 2s10 4.5 10 10-4.5 10-10 10zm0-18c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8z"
        data-original="#000000"
      />
      <path
        d="M12 17c-.6 0-1-.4-1-1v-5c0-.6.4-1 1-1s1 .4 1 1v5c0 .6-.4 1-1 1z"
        data-original="#000000"
      />
      <circle cx="12" cy="8" r="1" data-original="#000000" />
    </svg>
  );
};
